import { useAuth } from "@/contexts/auth/AuthContext";
import ArrowRight from "@/components/icons/ArrowRight";
import {
  StyledButton,
  ButtonTypes,
  ButtonSizes,
  IconTypes,
} from "../StyledButton";
import ArrowDown from "../icons/ArrowDown";

export const Hero = () => {
  return (
    <div className="min-h-[424px] border-b border-tab-border bg-[url('/assets/homepage/hero_digital_screen.png')] bg-cover bg-left bg-no-repeat py-11 medium:bg-fixed medium:py-[168px] ">
      <div className="flex max-w-screen-large large:mx-auto ">
        <div className="flex w-[95%] flex-col justify-center gap-6 pl-4 small:w-[50%] small:gap-8 small:pl-10 medium:w-[75%] medium:gap-14 medium:pl-14  large:w-[60%]">
          <h1 className="font-teodor text-4xl text-black small:text-[40px] medium:text-8xl">
            Elevate Student Learning with the XQ Competencies
          </h1>
          <h2 className="font-roobert text-xl font-medium text-dark-color medium:text-2xl">
            {
              "XQ Competency Navigator’s tools and resources help educators empower students with essential skills for the modern world."
            }
          </h2>
          <HeroButtons />
        </div>
      </div>
    </div>
  );
};

const HeroButtons = () => {
  const { openLoginPrompt, user } = useAuth();
  const isLoggedIn = !!user;

  const scrollDown = () => {
    const anchor = document.getElementById("page-content");
    if (anchor) {
      anchor.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="flex gap-2">
      {!isLoggedIn && (
        <StyledButton
          buttonType={ButtonTypes.Primary}
          size={ButtonSizes.Medium}
          iconType={IconTypes.Right}
          onClick={() => openLoginPrompt("HP_hero")}
          className="w-fit medium:h-16 medium:pl-6 medium:pr-4"
        >
          <span className="hidden medium:inline">Sign in to get started</span>
          <span className="medium:hidden">Get started</span>
          <ArrowRight fill="#FFFFFF" />
        </StyledButton>
      )}
      <StyledButton
        buttonType={isLoggedIn ? ButtonTypes.Primary : ButtonTypes.Secondary}
        size={ButtonSizes.Medium}
        iconType={IconTypes.Right}
        onClick={scrollDown}
        className={`w-fit medium:h-16 medium:pl-6 medium:pr-4 ${
          !isLoggedIn ? "bg-white" : ""
        }`}
      >
        Learn More
        <ArrowDown fill={isLoggedIn ? "#FFFFFF" : "#145758"} />
      </StyledButton>
    </div>
  );
};
